import { applyPluginRulesFromQueryParam } from '@mailonline/dmg-ads-core/src/config'
import { registerPlugin } from '@mailonline/dmg-ads-core/src/plugin-registry'

registerPlugin('debug.setPlugin', {
  init,
  isAdsFreeSupported: true,
  ccpa: { enabledIfDissent: true },
  gdpr: { enabledIfDissent: true },
})

function init({ queryParams }) {
  applyPluginRulesFromQueryParam(queryParams)
}
